
import axios from 'axios';
import { getToken } from '../utils/auth';

const API_BASE_URL = process.env.REACT_APP_API_BACKEND_URL || 'http://localhost:4001';
// Create base axios instance
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'ngrok-skip-browser-warning': 'true', // avoids ngrok's HTML interstitial page on free tier, harmless otherwise
  },
});

// Create a separate instance for temp token requests
export const tempApi = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'ngrok-skip-browser-warning': 'true',
  },
});

// // Regular API interceptor (for normal requests)
// api.interceptors.request.use(
//   (config) => {
//     const token = localStorage.getItem('token');
//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`;
//     }
//     return config;
//   },
//   (error) => Promise.reject(error)
// );



api.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Temp API interceptor - NEVER attaches token automatically
// We'll manually add temp token when needed
tempApi.interceptors.request.use(
  (config) => {
    // Don't auto-attach any token
    return config;
  },
  (error) => Promise.reject(error)
);

// Common error interceptor
const errorHandler = (error) => {
  const backendMessage =
    error.response?.data?.message ||
    error.response?.data?.error ||
    error.message ||
    'Something went wrong';
  return Promise.reject(new Error(backendMessage));
};

api.interceptors.response.use((response) => response, errorHandler);
tempApi.interceptors.response.use((response) => response, errorHandler);

export { api };